<template>
  <div class="child">
    <div>
      <div class="main">
        <div class="list">
          <div>实践中心</div>
          <ul>
            <li v-for="item in tabs" :key="item.index">
              {{item.type}}
            </li>
          </ul>
        </div>
        <div class="con">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PracticeCenter",
  data() {
    return {
      tabs: [
        {
          type: "成长型思维培养",
        },
        {
          type: "心理弹性干预",
        }
      ]
    };
  },
};
</script>
<style scoped src="../assets/style/child.css">
/* @import '../assets/style/child.css'; */
</style>



// WEBPACK FOOTER //
// src/components/PracticeCenter.vue